import { jsx } from "react/jsx-runtime";
import React, { useMemo, useCallback } from "react";
import { Grid } from "@perxis-auto/ui-kit/lib/components/Grid";
import { useConstructorContext, ConstructorContext } from "../../context/constructor.js";
import { prepareConstructorLayout } from "../../lib/constructor/prepareConstructorLayout.js";
import { ConstructorItem } from "../constructorItem/ConstructorItem.js";
function ConstructorGrid({
  layout,
  isSubConstructor = false
}) {
  const { widgets } = useConstructorContext();
  const preparedLayout = prepareConstructorLayout(layout, isSubConstructor);
  const { type, Container = React.Fragment, containerProps, ...subPreparedLayout } = preparedLayout;
  const subContextValue = useMemo(
    () => ({
      widgets,
      layout: subPreparedLayout
    }),
    [subPreparedLayout, widgets]
  );
  const renderItem = useCallback((item) => {
    return /* @__PURE__ */ jsx(ConstructorItem, { item });
  }, []);
  const renderGrid = useCallback((grid) => {
    return /* @__PURE__ */ jsx(ConstructorGrid, { layout: grid });
  }, []);
  if (type && !isSubConstructor) {
    return /* @__PURE__ */ jsx(Container, { ...containerProps, children: /* @__PURE__ */ jsx(ConstructorContext.Provider, { value: subContextValue, children: renderItem({ ...subPreparedLayout, type }) }) });
  }
  return /* @__PURE__ */ jsx(Grid, { grid: preparedLayout, renderItem, renderGrid });
}
export {
  ConstructorGrid
};
